import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, IconButton, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Divider, Tooltip, Paper } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
interface VirtualAccount {
  id: string;
  corridor: string;
  partner: string;
  account: string;
  currency: string;
  balance: string;
  balanceNum: number;
  threshold: string;
  thresholdNum: number;
  status: 'Healthy' | 'Low' | 'Critical';
}
const VIRTUAL_ACCOUNTS: VirtualAccount[] = [{
  id: '1',
  corridor: 'Nigeria-US',
  partner: 'First Bank Nigeria',
  account: 'VA-NG-USD-001',
  currency: 'USD',
  balance: '$127,500',
  balanceNum: 127500,
  threshold: '$50,000',
  thresholdNum: 50000,
  status: 'Healthy'
}, {
  id: '2',
  corridor: 'Ghana-UK',
  partner: 'GTBank',
  account: 'VA-GH-GBP-001',
  currency: 'GBP',
  balance: '£45,200',
  balanceNum: 45200,
  threshold: '£30,000',
  thresholdNum: 30000,
  status: 'Healthy'
}, {
  id: '3',
  corridor: 'Nigeria-US',
  partner: 'Zenith Bank',
  account: 'VA-NG-USD-002',
  currency: 'USD',
  balance: '$15,400',
  balanceNum: 15400,
  threshold: '$50,000',
  thresholdNum: 50000,
  status: 'Low'
}, {
  id: '4',
  corridor: 'Senegal-France',
  partner: 'Orange Money',
  account: 'VA-SN-EUR-001',
  currency: 'EUR',
  balance: '€8,500',
  balanceNum: 8500,
  threshold: '€25,000',
  thresholdNum: 25000,
  status: 'Low'
}, {
  id: '5',
  corridor: 'Ghana-Germany',
  partner: 'Guaranty Trust Bank',
  account: 'VA-GH-EUR-002',
  currency: 'EUR',
  balance: '€52,000',
  balanceNum: 52000,
  threshold: '€40,000',
  thresholdNum: 40000,
  status: 'Healthy'
}, {
  id: '6',
  corridor: 'Nigeria-UK',
  partner: 'Ecobank Nigeria',
  account: 'VA-NG-GBP-001',
  currency: 'GBP',
  balance: '£12,000',
  balanceNum: 12000,
  threshold: '£25,000',
  thresholdNum: 25000,
  status: 'Low'
}, {
  id: '7',
  corridor: 'Ghana-UK',
  partner: 'MTN Mobile Money',
  account: 'VA-GH-GBP-002',
  currency: 'GBP',
  balance: '£78,500',
  balanceNum: 78500,
  threshold: '£30,000',
  thresholdNum: 30000,
  status: 'Healthy'
}, {
  id: '8',
  corridor: 'Senegal-France',
  partner: 'Ecobank Senegal',
  account: 'VA-SN-EUR-002',
  currency: 'EUR',
  balance: '€95,000',
  balanceNum: 95000,
  threshold: '€40,000',
  thresholdNum: 40000,
  status: 'Healthy'
}];
interface Settlement {
  id: string;
  fromAccount: string;
  toCbsGl: string;
  amount: string;
  currency: string;
  initiated: string;
  status: 'Processing' | 'Queued' | 'Completed' | 'Failed' | 'Reversed';
  partner: string;
  initiatedBy: string;
  method: string;
  expectedCompletion: string;
}
const SETTLEMENTS: Settlement[] = [{
  id: 'SETTLE-20250101-001',
  fromAccount: 'VA-NG-USD-001',
  toCbsGl: '1110-NG-USD',
  amount: '$50,000',
  currency: 'USD',
  initiated: '2025-01-01 12:30:00 UTC',
  status: 'Processing',
  partner: 'First Bank Nigeria',
  initiatedBy: 'Jane Okafor (Operations Manager)',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 14:30:00 UTC'
}, {
  id: 'SETTLE-20250101-002',
  fromAccount: 'VA-GH-GBP-001',
  toCbsGl: '1110-GH-GBP',
  amount: '£25,000',
  currency: 'GBP',
  initiated: '2025-01-01 13:15:00 UTC',
  status: 'Processing',
  partner: 'GTBank',
  initiatedBy: 'System Auto-Sweep',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 15:15:00 UTC'
}, {
  id: 'SETTLE-20250101-003',
  fromAccount: 'VA-NG-USD-002',
  toCbsGl: '1110-NG-USD',
  amount: '$15,000',
  currency: 'USD',
  initiated: '2025-01-01 13:45:00 UTC',
  status: 'Queued',
  partner: 'Zenith Bank',
  initiatedBy: 'System Auto-Sweep',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 15:45:00 UTC'
}, {
  id: 'SETTLE-20250101-004',
  fromAccount: 'VA-SN-EUR-001',
  toCbsGl: '1110-SN-EUR',
  amount: '€12,500',
  currency: 'EUR',
  initiated: '2025-01-01 14:00:00 UTC',
  status: 'Queued',
  partner: 'Orange Money',
  initiatedBy: 'System Auto-Sweep',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 16:00:00 UTC'
}, {
  id: 'SETTLE-20250101-000',
  fromAccount: 'VA-NG-USD-001',
  toCbsGl: '1110-NG-USD',
  amount: '$127,500',
  currency: 'USD',
  initiated: '2025-01-01 09:30:00 UTC',
  status: 'Completed',
  partner: 'First Bank Nigeria',
  initiatedBy: 'System Auto-Sweep',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 11:30:00 UTC'
}, {
  id: 'SETTLE-20250100-999',
  fromAccount: 'VA-GH-GBP-001',
  toCbsGl: '1110-GH-GBP',
  amount: '£45,200',
  currency: 'GBP',
  initiated: '2025-01-01 08:15:00 UTC',
  status: 'Completed',
  partner: 'GTBank',
  initiatedBy: 'System Auto-Sweep',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 10:15:00 UTC'
}, {
  id: 'SETTLE-20250100-998',
  fromAccount: 'VA-SN-EUR-002',
  toCbsGl: '1110-SN-EUR',
  amount: '€30,000',
  currency: 'EUR',
  initiated: '2025-01-01 07:00:00 UTC',
  status: 'Completed',
  partner: 'Ecobank Senegal',
  initiatedBy: 'System Auto-Sweep',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 09:00:00 UTC'
}, {
  id: 'SETTLE-20250100-997',
  fromAccount: 'VA-NG-GBP-001',
  toCbsGl: '1110-NG-GBP',
  amount: '£10,000',
  currency: 'GBP',
  initiated: '2025-01-01 06:30:00 UTC',
  status: 'Failed',
  partner: 'Ecobank Nigeria',
  initiatedBy: 'System Auto-Sweep',
  method: 'Internal FT (Flexcube IAFT)',
  expectedCompletion: '2025-01-01 08:30:00 UTC'
}];
export default function FundingSettlement({
  onLogout
}: {
  onLogout: () => void;
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedSettlement, setSelectedSettlement] = useState<Settlement | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [lastUpdated, setLastUpdated] = useState('2 minutes ago');
  const [showLowBalanceList, setShowLowBalanceList] = useState(false);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const handleRowClick = (settlement: Settlement) => {
    setSelectedSettlement(settlement);
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedSettlement(null);
  };
  const getFilteredSettlements = () => {
    switch (activeTab) {
      case 0:
        // Pending
        return SETTLEMENTS.filter(s => s.status === 'Processing' || s.status === 'Queued');
      case 1:
        // Completed
        return SETTLEMENTS.filter(s => s.status === 'Completed');
      case 2:
        // Failed/Reversed
        return SETTLEMENTS.filter(s => s.status === 'Failed' || s.status === 'Reversed');
      case 3:
        // All
        return SETTLEMENTS;
      default:
        return SETTLEMENTS;
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Healthy':
      case 'Completed':
        return '#0B7923';
      case 'Low':
        return '#B38600';
      case 'Critical':
      case 'Failed':
      case 'Reversed':
        return '#AE2A19';
      case 'Processing':
        return '#0052CC';
      case 'Queued':
        return '#6B7280';
      default:
        return '#6B7280';
    }
  };
  const getStatusBg = (status: string) => {
    switch (status) {
      case 'Healthy':
        return '#FFFFFF';
      case 'Low':
        return '#FFFBEB';
      case 'Critical':
        return '#FEF2F2';
      default:
        return '#FFFFFF';
    }
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    bgcolor: '#F8F9FA'
  }} data-id="element-4077">
      <TopBar onMenuClick={() => setSidebarOpen(!sidebarOpen)} onLogout={onLogout} data-id="element-4078" />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} activePage="funding-settlement" data-id="element-4079" />

      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        sm: `calc(100% - 240px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-4080">
        <Container maxWidth="xl" data-id="element-4081">
          {/* SECTION 1 - VIRTUAL ACCOUNT BALANCES */}
          <Box sx={{
          mb: 4
        }} data-id="element-4082">
            <Typography variant="h5" fontWeight={700} color="#1F2937" mb={2} data-id="element-4083">
              Virtual Accounts & Prefunding Status
            </Typography>
            <Grid container spacing={2} data-id="element-4084">
              {/* Card 1 */}
              <Grid item xs={12} sm={6} md={3} data-id="element-4085">
                <Card elevation={0} sx={{
                bgcolor: '#F3F5F7',
                border: '1px solid #E5E7EB',
                borderRadius: 2,
                height: '100%',
                boxShadow: '0px 1px 2px rgba(0,0,0,0.05)'
              }} data-id="element-4086">
                  <CardContent sx={{
                  p: 2,
                  '&:last-child': {
                    pb: 2
                  }
                }} data-id="element-4087">
                    <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                  }} data-id="element-4088">
                      <Icon icon="lucide:wallet" width={24} color="#6B7280" style={{
                      marginRight: 8
                    }} data-id="element-4089" />
                      <Typography variant="body2" color="#6B7280" data-id="element-4090">
                        Total Prefund Balance
                      </Typography>
                    </Box>
                    <Typography variant="h4" fontWeight={700} color="#1F2937" sx={{
                    fontSize: '28px',
                    mb: 0.5
                  }} data-id="element-4091">
                      $547,320.00 USD
                    </Typography>
                    <Typography variant="body2" color="#6B7280" mb={1} data-id="element-4092">
                      Across 8 active corridors
                    </Typography>
                    <Typography variant="caption" fontWeight={600} color="#0B7923" data-id="element-4093">
                      ↑ +$25,000 from yesterday
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              {/* Card 2 */}
              <Grid item xs={12} sm={6} md={3} data-id="element-4094">
                <Card elevation={0} sx={{
                bgcolor: '#FFFBEB',
                border: '1px solid #B38600',
                borderRadius: 2,
                height: '100%',
                position: 'relative'
              }} onMouseEnter={() => setShowLowBalanceList(true)} onMouseLeave={() => setShowLowBalanceList(false)} data-id="element-4095">
                  <CardContent sx={{
                  p: 2,
                  '&:last-child': {
                    pb: 2
                  }
                }} data-id="element-4096">
                    <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                  }} data-id="element-4097">
                      <Icon icon="lucide:alert-triangle" width={24} color="#B38600" style={{
                      marginRight: 8
                    }} data-id="element-4098" />
                      <Typography variant="body2" color="#B38600" fontWeight={600} data-id="element-4099">
                        Accounts Below Threshold
                      </Typography>
                    </Box>
                    <Typography variant="h4" fontWeight={700} color="#B38600" sx={{
                    fontSize: '28px',
                    mb: 0.5
                  }} data-id="element-4100">
                      3
                    </Typography>
                    <Typography variant="body2" color="#AE2A19" mb={1.5} data-id="element-4101">
                      Immediate action required
                    </Typography>
                    <Button variant="contained" size="small" sx={{
                    bgcolor: '#B38600',
                    '&:hover': {
                      bgcolor: '#92400E'
                    },
                    fontSize: '12px',
                    py: 0.5
                  }} data-id="element-4102">
                      Top Up Now
                    </Button>

                    {showLowBalanceList && <Paper elevation={4} sx={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    mt: 1,
                    p: 2,
                    zIndex: 10,
                    border: '1px solid #E5E7EB',
                    borderRadius: 2
                  }} data-id="element-4103">
                        <Typography variant="caption" display="block" mb={0.5} data-id="element-4104">
                          • Nigeria-US: $15,400 (threshold $50k)
                        </Typography>
                        <Typography variant="caption" display="block" mb={0.5} data-id="element-4105">
                          • Ghana-UK: £12,000 (threshold £25k)
                        </Typography>
                        <Typography variant="caption" display="block" data-id="element-4106">
                          • Senegal-France: €8,500 (threshold €25k)
                        </Typography>
                      </Paper>}
                  </CardContent>
                </Card>
              </Grid>

              {/* Card 3 */}
              <Grid item xs={12} sm={6} md={3} data-id="element-4107">
                <Card elevation={0} sx={{
                bgcolor: '#F3F5F7',
                border: '1px solid #E5E7EB',
                borderRadius: 2,
                height: '100%'
              }} data-id="element-4108">
                  <CardContent sx={{
                  p: 2,
                  '&:last-child': {
                    pb: 2
                  }
                }} data-id="element-4109">
                    <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                  }} data-id="element-4110">
                      <Icon icon="lucide:send" width={24} color="#0052CC" style={{
                      marginRight: 8
                    }} data-id="element-4111" />
                      <Typography variant="body2" color="#6B7280" data-id="element-4112">
                        Pending Settlements
                      </Typography>
                    </Box>
                    <Typography variant="h4" fontWeight={700} color="#0052CC" sx={{
                    fontSize: '28px',
                    mb: 0.5
                  }} data-id="element-4113">
                      7
                    </Typography>
                    <Typography variant="body2" color="#6B7280" mb={1} data-id="element-4114">
                      Total: $234,500 USD
                    </Typography>
                    <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }} data-id="element-4115">
                      <Typography variant="caption" color="#6B7280" data-id="element-4116">
                        First settlement from 2 hours ago
                      </Typography>
                      <Button variant="contained" size="small" sx={{
                      bgcolor: '#0052CC',
                      '&:hover': {
                        bgcolor: '#003DA8'
                      },
                      fontSize: '12px',
                      py: 0.5,
                      minWidth: 'auto'
                    }} data-id="element-4117">
                        Process Now
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Card 4 */}
              <Grid item xs={12} sm={6} md={3} data-id="element-4118">
                <Card elevation={0} sx={{
                bgcolor: '#ECFDF5',
                border: '1px solid #0B7923',
                borderRadius: 2,
                height: '100%'
              }} data-id="element-4119">
                  <CardContent sx={{
                  p: 2,
                  '&:last-child': {
                    pb: 2
                  }
                }} data-id="element-4120">
                    <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                  }} data-id="element-4121">
                      <Icon icon="lucide:link" width={24} color="#0B7923" style={{
                      marginRight: 8
                    }} data-id="element-4122" />
                      <Typography variant="body2" color="#0B7923" fontWeight={600} data-id="element-4123">
                        Flexcube (CBS) Connection
                      </Typography>
                    </Box>
                    <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: 0.5
                  }} data-id="element-4124">
                      <Typography variant="h6" fontWeight={700} color="#0B7923" sx={{
                      mr: 1
                    }} data-id="element-4125">
                        Connected ✓
                      </Typography>
                      <Box sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      bgcolor: '#0B7923',
                      animation: 'pulse 2s infinite',
                      '@keyframes pulse': {
                        '0%': {
                          boxShadow: '0 0 0 0 rgba(11, 121, 35, 0.7)'
                        },
                        '70%': {
                          boxShadow: '0 0 0 6px rgba(11, 121, 35, 0)'
                        },
                        '100%': {
                          boxShadow: '0 0 0 0 rgba(11, 121, 35, 0)'
                        }
                      }
                    }} data-id="element-4126" />
                    </Box>
                    <Typography variant="body2" color="#6B7280" mb={1.5} data-id="element-4127">
                      Last sync: 2025-01-01 14:35:00 UTC
                    </Typography>
                    <Typography variant="caption" fontWeight={600} color="#0B7923" data-id="element-4128">
                      Latency: 180ms
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* SECTION 2 - VIRTUAL ACCOUNT DETAILS */}
          <Box sx={{
          mb: 4
        }} data-id="element-4129">
            <Typography variant="h5" fontWeight={700} color="#1F2937" mb={2} data-id="element-4130">
              Account Balances by Corridor
            </Typography>
            <TableContainer component={Paper} elevation={0} sx={{
            border: '1px solid #E5E7EB',
            borderRadius: 2
          }} data-id="element-4131">
              <Table size="small" data-id="element-4132">
                <TableHead data-id="element-4133">
                  <TableRow sx={{
                  bgcolor: '#F3F5F7'
                }} data-id="element-4134">
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4135">
                      Corridor
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4136">
                      Partner
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4137">
                      Virtual Account
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4138">
                      Currency
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4139">
                      Current Balance
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4140">
                      Threshold
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4141">
                      Status
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4142">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody data-id="element-4143">
                  {VIRTUAL_ACCOUNTS.map(row => <TableRow key={row.id} sx={{
                  bgcolor: getStatusBg(row.status),
                  '& td': {
                    borderBottom: '1px solid #E5E7EB'
                  }
                }} data-id="element-4144">
                      <TableCell sx={{
                    borderLeft: `3px solid ${getStatusColor(row.status)}`
                  }} data-id="element-4145">
                        {row.corridor}
                      </TableCell>
                      <TableCell data-id="element-4146">{row.partner}</TableCell>
                      <TableCell sx={{
                    fontFamily: 'monospace',
                    fontSize: '12px'
                  }} data-id="element-4147">
                        {row.account}
                      </TableCell>
                      <TableCell data-id="element-4148">{row.currency}</TableCell>
                      <TableCell sx={{
                    fontWeight: 600
                  }} data-id="element-4149">
                        {row.balance}
                      </TableCell>
                      <TableCell data-id="element-4150">{row.threshold}</TableCell>
                      <TableCell data-id="element-4151">
                        <Chip label={row.status === 'Healthy' ? '✓ Healthy' : row.status === 'Low' ? '⚠️ Low' : '❌ Critical'} size="small" sx={{
                      bgcolor: getStatusColor(row.status),
                      color: '#FFFFFF',
                      fontWeight: 600,
                      fontSize: '11px',
                      height: 20
                    }} data-id="element-4152" />
                      </TableCell>
                      <TableCell data-id="element-4153">
                        <Box sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'center'
                    }} data-id="element-4154">
                          <Button variant="contained" size="small" sx={{
                        bgcolor: '#0052CC',
                        '&:hover': {
                          bgcolor: '#003DA8'
                        },
                        fontSize: '11px',
                        py: 0.5,
                        px: 1,
                        minWidth: 'auto'
                      }} data-id="element-4155">
                            Top Up
                          </Button>
                          <Button variant="outlined" size="small" sx={{
                        color: '#6B7280',
                        borderColor: '#D1D5DB',
                        bgcolor: '#F3F5F7',
                        fontSize: '11px',
                        py: 0.5,
                        px: 1,
                        minWidth: 'auto'
                      }} data-id="element-4156">
                            Details
                          </Button>
                          <IconButton size="small" sx={{
                        color: '#6B7280'
                      }} data-id="element-4157">
                            <Icon icon="lucide:more-vertical" width={16} data-id="element-4158" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
              <Box sx={{
              p: 1.5,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }} data-id="element-4159">
                <Typography variant="body2" color="#6B7280" data-id="element-4160">
                  Showing 1-8 of 8 accounts
                </Typography>
                <Box sx={{
                display: 'flex',
                gap: 1
              }} data-id="element-4161">
                  <Button size="small" disabled data-id="element-4162">
                    &lt; Previous
                  </Button>
                  <Button size="small" disabled data-id="element-4163">
                    Next &gt;
                  </Button>
                </Box>
              </Box>
            </TableContainer>
          </Box>

          {/* SECTION 3 - SETTLEMENT PROCESSING */}
          <Box sx={{
          mb: 4
        }} data-id="element-4164">
            <Typography variant="h5" fontWeight={700} color="#1F2937" mb={2} data-id="element-4165">
              Settlement to Flexcube CBS
            </Typography>
            <Box sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mb: 2
          }} data-id="element-4166">
              <Tabs value={activeTab} onChange={handleTabChange} sx={{
              minHeight: 40,
              '& .MuiTab-root': {
                textTransform: 'none',
                minHeight: 40,
                fontWeight: 500,
                color: '#6B7280',
                '&.Mui-selected': {
                  color: '#0052CC',
                  fontWeight: 700
                }
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#0052CC'
              }
            }} data-id="element-4167">
                <Tab label="Pending Settlements" data-id="element-4168" />
                <Tab label="Completed Today" data-id="element-4169" />
                <Tab label="Failed/Reversed" data-id="element-4170" />
                <Tab label="All History" data-id="element-4171" />
              </Tabs>
            </Box>

            <TableContainer component={Paper} elevation={0} sx={{
            border: '1px solid #E5E7EB',
            borderRadius: 2
          }} data-id="element-4172">
              <Table size="small" data-id="element-4173">
                <TableHead data-id="element-4174">
                  <TableRow sx={{
                  bgcolor: '#F3F5F7'
                }} data-id="element-4175">
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4176">
                      Settlement ID
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4177">
                      From Account
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4178">
                      To CBS GL
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4179">
                      Amount
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4180">
                      Initiated
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4181">
                      Status
                    </TableCell>
                    <TableCell sx={{
                    color: '#0052CC',
                    fontWeight: 700
                  }} data-id="element-4182">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody data-id="element-4183">
                  {getFilteredSettlements().map(row => <TableRow key={row.id} hover onClick={() => handleRowClick(row)} sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: '#F9FAFB'
                  },
                  '& td': {
                    borderBottom: '1px solid #E5E7EB'
                  }
                }} data-id="element-4184">
                      <TableCell sx={{
                    fontFamily: 'monospace',
                    fontSize: '12px'
                  }} data-id="element-4185">
                        {row.id}
                      </TableCell>
                      <TableCell sx={{
                    fontFamily: 'monospace',
                    fontSize: '12px'
                  }} data-id="element-4186">
                        {row.fromAccount}
                      </TableCell>
                      <TableCell sx={{
                    fontFamily: 'monospace',
                    fontSize: '12px'
                  }} data-id="element-4187">
                        {row.toCbsGl}
                      </TableCell>
                      <TableCell sx={{
                    fontWeight: 600
                  }} data-id="element-4188">
                        {row.amount} {row.currency}
                      </TableCell>
                      <TableCell sx={{
                    fontSize: '12px'
                  }} data-id="element-4189">
                        {row.initiated}
                      </TableCell>
                      <TableCell data-id="element-4190">
                        <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1
                    }} data-id="element-4191">
                          {row.status === 'Processing' && <Icon icon="lucide:loader-2" width={16} color="#0052CC" style={{
                        animation: 'spin 2s linear infinite'
                      }} data-id="element-4192" />}
                          {row.status === 'Queued' && <Box sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        bgcolor: '#6B7280'
                      }} data-id="element-4193" />}
                          {row.status === 'Completed' && <Icon icon="lucide:check-circle" width={16} color="#0B7923" data-id="element-4194" />}
                          {(row.status === 'Failed' || row.status === 'Reversed') && <Icon icon="lucide:x-circle" width={16} color="#AE2A19" data-id="element-4195" />}
                          <Typography variant="caption" fontWeight={600} color={getStatusColor(row.status)} data-id="element-4196">
                            {row.status}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell data-id="element-4197">
                        <Box sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'center'
                    }} data-id="element-4198">
                          <Button variant="outlined" size="small" sx={{
                        color: '#6B7280',
                        borderColor: '#D1D5DB',
                        bgcolor: '#F3F5F7',
                        fontSize: '11px',
                        py: 0.5,
                        px: 1,
                        minWidth: 'auto'
                      }} onClick={e => {
                        e.stopPropagation();
                        handleRowClick(row);
                      }} data-id="element-4199">
                            View Details
                          </Button>
                          <IconButton size="small" sx={{
                        color: '#6B7280'
                      }} data-id="element-4200">
                            <Icon icon="lucide:more-vertical" width={16} data-id="element-4201" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>)}
                  {getFilteredSettlements().length === 0 && <TableRow data-id="element-4202">
                      <TableCell colSpan={7} align="center" sx={{
                    py: 3
                  }} data-id="element-4203">
                        No settlements found
                      </TableCell>
                    </TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* SECTION 4 - RECENT ACTIVITY & ALERTS */}
          <Box sx={{
          mb: 4
        }} data-id="element-4204">
            <Typography variant="h5" fontWeight={700} color="#1F2937" mb={2} data-id="element-4205">
              Recent Settlement Activity
            </Typography>
            <Grid container spacing={3} data-id="element-4206">
              <Grid item xs={12} md={6} data-id="element-4207">
                <Card elevation={0} sx={{
                border: '1px solid #E5E7EB',
                borderRadius: 2,
                height: '100%'
              }} data-id="element-4208">
                  <CardContent sx={{
                  p: 2
                }} data-id="element-4209">
                    <Typography variant="subtitle2" fontWeight={700} mb={2} data-id="element-4210">
                      Completed Settlements (Today)
                    </Typography>
                    <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5
                  }} data-id="element-4211">
                      {SETTLEMENTS.filter(s => s.status === 'Completed').slice(0, 5).map(s => <Box key={s.id} sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      pb: 1.5,
                      borderBottom: '1px solid #E5E7EB',
                      '&:last-child': {
                        borderBottom: 'none',
                        pb: 0
                      }
                    }} data-id="element-4212">
                            <Icon icon="lucide:check-circle" width={16} color="#0B7923" data-id="element-4213" />
                            <Box sx={{
                        flexGrow: 1
                      }} data-id="element-4214">
                              <Typography variant="body2" color="#374151" data-id="element-4215">
                                <span style={{
                            fontFamily: 'monospace'
                          }} data-id="element-4216">
                                  {s.id}
                                </span>{' '}
                                | <strong data-id="element-4217">{s.amount}</strong> | {s.partner}
                              </Typography>
                              <Typography variant="caption" color="#6B7280" data-id="element-4218">
                                Completed at {s.expectedCompletion}
                              </Typography>
                            </Box>
                          </Box>)}
                    </Box>
                    <Typography variant="caption" color="#0052CC" sx={{
                    display: 'block',
                    mt: 2,
                    cursor: 'pointer',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }} data-id="element-4219">
                      View All Completed
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} data-id="element-4220">
                <Card elevation={0} sx={{
                border: '1px solid #E5E7EB',
                borderRadius: 2,
                height: '100%'
              }} data-id="element-4221">
                  <CardContent sx={{
                  p: 2
                }} data-id="element-4222">
                    <Typography variant="subtitle2" fontWeight={700} mb={2} data-id="element-4223">
                      System Alerts & Notifications
                    </Typography>
                    <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5
                  }} data-id="element-4224">
                      <Box sx={{
                      bgcolor: '#ECFDF5',
                      border: '1px solid #0B7923',
                      borderRadius: 1,
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 1
                    }} data-id="element-4225">
                        <Icon icon="lucide:check-circle" width={16} color="#0B7923" style={{
                        marginTop: 2
                      }} data-id="element-4226" />
                        <Typography variant="caption" color="#0B7923" sx={{
                        flexGrow: 1
                      }} data-id="element-4227">
                          All accounts above critical threshold
                        </Typography>
                        <Icon icon="lucide:x" width={14} color="#0B7923" style={{
                        cursor: 'pointer'
                      }} data-id="element-4228" />
                      </Box>
                      <Box sx={{
                      bgcolor: '#FFFBEB',
                      border: '1px solid #B38600',
                      borderRadius: 1,
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 1
                    }} data-id="element-4229">
                        <Icon icon="lucide:alert-triangle" width={16} color="#B38600" style={{
                        marginTop: 2
                      }} data-id="element-4230" />
                        <Typography variant="caption" color="#92400E" sx={{
                        flexGrow: 1
                      }} data-id="element-4231">
                          2 accounts below optimal threshold. Top-up recommended
                          within next 4 hours.
                        </Typography>
                        <Icon icon="lucide:x" width={14} color="#B38600" style={{
                        cursor: 'pointer'
                      }} data-id="element-4232" />
                      </Box>
                      <Box sx={{
                      bgcolor: '#EFF6FF',
                      border: '1px solid #0052CC',
                      borderRadius: 1,
                      p: 1.5,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 1
                    }} data-id="element-4233">
                        <Icon icon="lucide:info" width={16} color="#0052CC" style={{
                        marginTop: 2
                      }} data-id="element-4234" />
                        <Typography variant="caption" color="#0052CC" sx={{
                        flexGrow: 1
                      }} data-id="element-4235">
                          CBS latency elevated to 250ms. Normal operations
                          continue.
                        </Typography>
                        <Icon icon="lucide:x" width={14} color="#0052CC" style={{
                        cursor: 'pointer'
                      }} data-id="element-4236" />
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* BOTTOM ACTION BAR */}
          <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          bgcolor: '#FFFFFF',
          border: '1px solid #E5E7EB',
          borderRadius: 2,
          flexWrap: 'wrap',
          gap: 2
        }} data-id="element-4237">
            <Box sx={{
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap'
          }} data-id="element-4238">
              <Button variant="outlined" sx={{
              color: '#6B7280',
              borderColor: '#D1D5DB',
              bgcolor: '#F3F5F7'
            }} data-id="element-4239">
                Manual Top Up Request
              </Button>
              <Button variant="contained" sx={{
              bgcolor: '#0052CC',
              '&:hover': {
                bgcolor: '#003DA8'
              }
            }} data-id="element-4240">
                Generate Settlement Report
              </Button>
              <Button variant="contained" sx={{
              bgcolor: '#0052CC',
              '&:hover': {
                bgcolor: '#003DA8'
              }
            }} data-id="element-4241">
                Configure Thresholds
              </Button>
              <Button variant="outlined" sx={{
              color: '#0052CC',
              borderColor: '#0052CC'
            }} data-id="element-4242">
                Refresh Now
              </Button>
            </Box>
            <Typography variant="caption" color="#6B7280" data-id="element-4243">
              Last updated: {lastUpdated} | Next refresh in 4 minutes
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* SETTLEMENT DETAIL MODAL */}
      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="md" fullWidth PaperProps={{
      sx: {
        borderRadius: 2,
        border: '1px solid #E5E7EB'
      }
    }} data-id="element-4244">
        {selectedSettlement && <>
            <DialogTitle sx={{
          borderBottom: '1px solid #E5E7EB',
          pb: 2
        }} data-id="element-4245">
              <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }} data-id="element-4246">
                <Typography variant="h6" fontWeight={700} color="#1F2937" data-id="element-4247">
                  Settlement {selectedSettlement.id}
                </Typography>
                <Chip label={selectedSettlement.status} size="small" sx={{
              bgcolor: getStatusColor(selectedSettlement.status),
              color: '#FFFFFF',
              fontWeight: 600
            }} data-id="element-4248" />
              </Box>
            </DialogTitle>
            <DialogContent sx={{
          pt: 3
        }} data-id="element-4249">
              <Grid container spacing={4} data-id="element-4250">
                {/* LEFT COLUMN */}
                <Grid item xs={12} md={6} data-id="element-4251">
                  <Typography variant="subtitle2" fontWeight={700} mb={2} color="#1F2937" data-id="element-4252">
                    Account Details
                  </Typography>
                  <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5
              }} data-id="element-4253">
                    <Box data-id="element-4254">
                      <Typography variant="caption" color="#6B7280" data-id="element-4255">
                        From Account
                      </Typography>
                      <Typography variant="body2" fontFamily="monospace" data-id="element-4256">
                        {selectedSettlement.fromAccount}
                      </Typography>
                    </Box>
                    <Box data-id="element-4257">
                      <Typography variant="caption" color="#6B7280" data-id="element-4258">
                        Partner
                      </Typography>
                      <Typography variant="body2" color="#0052CC" sx={{
                    cursor: 'pointer',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }} data-id="element-4259">
                        {selectedSettlement.partner}
                      </Typography>
                    </Box>
                    <Box data-id="element-4260">
                      <Typography variant="caption" color="#6B7280" data-id="element-4261">
                        Amount
                      </Typography>
                      <Typography variant="body2" fontWeight={700} data-id="element-4262">
                        {selectedSettlement.amount}{' '}
                        {selectedSettlement.currency}
                      </Typography>
                    </Box>
                    <Box data-id="element-4263">
                      <Typography variant="caption" color="#6B7280" data-id="element-4264">
                        Initiated
                      </Typography>
                      <Typography variant="body2" data-id="element-4265">
                        {selectedSettlement.initiated}
                      </Typography>
                    </Box>
                    <Box data-id="element-4266">
                      <Typography variant="caption" color="#6B7280" data-id="element-4267">
                        Initiated By
                      </Typography>
                      <Typography variant="body2" data-id="element-4268">
                        {selectedSettlement.initiatedBy}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                {/* RIGHT COLUMN */}
                <Grid item xs={12} md={6} data-id="element-4269">
                  <Typography variant="subtitle2" fontWeight={700} mb={2} color="#1F2937" data-id="element-4270">
                    CBS Details
                  </Typography>
                  <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5
              }} data-id="element-4271">
                    <Box data-id="element-4272">
                      <Typography variant="caption" color="#6B7280" data-id="element-4273">
                        To CBS GL
                      </Typography>
                      <Typography variant="body2" fontFamily="monospace" data-id="element-4274">
                        {selectedSettlement.toCbsGl}
                      </Typography>
                    </Box>
                    <Box data-id="element-4275">
                      <Typography variant="caption" color="#6B7280" data-id="element-4276">
                        Settlement Method
                      </Typography>
                      <Typography variant="body2" data-id="element-4277">
                        {selectedSettlement.method}
                      </Typography>
                    </Box>
                    <Box data-id="element-4278">
                      <Typography variant="caption" color="#6B7280" data-id="element-4279">
                        Expected Completion
                      </Typography>
                      <Typography variant="body2" data-id="element-4280">
                        {selectedSettlement.expectedCompletion} (estimated)
                      </Typography>
                    </Box>
                    <Box data-id="element-4281">
                      <Typography variant="caption" color="#6B7280" data-id="element-4282">
                        Actual Completion
                      </Typography>
                      <Typography variant="body2" color="#6B7280" data-id="element-4283">
                        {selectedSettlement.status === 'Completed' ? selectedSettlement.expectedCompletion : '(pending)'}
                      </Typography>
                    </Box>
                    <Box data-id="element-4284">
                      <Typography variant="caption" color="#6B7280" data-id="element-4285">
                        CBS Status
                      </Typography>
                      <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }} data-id="element-4286">
                        <Box sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      bgcolor: selectedSettlement.status === 'Completed' ? '#0B7923' : '#6B7280'
                    }} data-id="element-4287" />
                        <Typography variant="body2" data-id="element-4288">
                          {selectedSettlement.status === 'Completed' ? 'Success' : 'Pending'}
                        </Typography>
                      </Box>
                    </Box>
                    <Box data-id="element-4289">
                      <Typography variant="caption" color="#6B7280" data-id="element-4290">
                        CBS Reference
                      </Typography>
                      <Typography variant="body2" color="#6B7280" data-id="element-4291">
                        {selectedSettlement.status === 'Completed' ? 'REF-987654321' : '(awaiting response)'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              <Divider sx={{
            my: 3
          }} data-id="element-4292" />

              {/* PROCESSING TIMELINE */}
              <Typography variant="subtitle2" fontWeight={700} mb={2} color="#1F2937" data-id="element-4293">
                Processing Timeline
              </Typography>
              <Box sx={{
            position: 'relative',
            pl: 2
          }} data-id="element-4294">
                <Box sx={{
              position: 'absolute',
              left: 23,
              top: 10,
              bottom: 10,
              width: 2,
              bgcolor: '#E5E7EB'
            }} data-id="element-4295" />

                <Box sx={{
              display: 'flex',
              mb: 2,
              position: 'relative',
              zIndex: 1
            }} data-id="element-4296">
                  <Typography sx={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#6B7280',
                width: 60,
                pt: 0.5
              }} data-id="element-4297">
                    12:30:00
                  </Typography>
                  <Box sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#0B7923',
                mt: 0.8,
                mx: 1.5,
                border: '2px solid #FFFFFF'
              }} data-id="element-4298" />
                  <Typography variant="body2" color="#374151" sx={{
                pt: 0.2
              }} data-id="element-4299">
                    Settlement initiated
                  </Typography>
                </Box>

                <Box sx={{
              display: 'flex',
              mb: 2,
              position: 'relative',
              zIndex: 1
            }} data-id="element-4300">
                  <Typography sx={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#6B7280',
                width: 60,
                pt: 0.5
              }} data-id="element-4301">
                    12:30:15
                  </Typography>
                  <Box sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#0B7923',
                mt: 0.8,
                mx: 1.5,
                border: '2px solid #FFFFFF'
              }} data-id="element-4302" />
                  <Typography variant="body2" color="#374151" sx={{
                pt: 0.2
              }} data-id="element-4303">
                    Validated against CBS GL
                  </Typography>
                </Box>

                <Box sx={{
              display: 'flex',
              mb: 2,
              position: 'relative',
              zIndex: 1
            }} data-id="element-4304">
                  <Typography sx={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#6B7280',
                width: 60,
                pt: 0.5
              }} data-id="element-4305">
                    12:30:30
                  </Typography>
                  <Box sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#0B7923',
                mt: 0.8,
                mx: 1.5,
                border: '2px solid #FFFFFF'
              }} data-id="element-4306" />
                  <Typography variant="body2" color="#374151" sx={{
                pt: 0.2
              }} data-id="element-4307">
                    Sent to Flexcube
                  </Typography>
                </Box>

                {selectedSettlement.status === 'Processing' && <Box sx={{
              display: 'flex',
              mb: 2,
              position: 'relative',
              zIndex: 1
            }} data-id="element-4308">
                    <Typography sx={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#6B7280',
                width: 60,
                pt: 0.5
              }} data-id="element-4309">
                      13:45:00
                    </Typography>
                    <Box sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#0052CC',
                mt: 0.8,
                mx: 1.5,
                border: '2px solid #FFFFFF'
              }} data-id="element-4310" />
                    <Typography variant="body2" color="#374151" sx={{
                pt: 0.2,
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }} data-id="element-4311">
                      Awaiting CBS response
                      <Icon icon="lucide:loader-2" width={14} color="#0052CC" style={{
                  animation: 'spin 2s linear infinite'
                }} data-id="element-4312" />
                    </Typography>
                  </Box>}

                {selectedSettlement.status === 'Failed' && <Box sx={{
              display: 'flex',
              mb: 2,
              position: 'relative',
              zIndex: 1
            }} data-id="element-4313">
                    <Typography sx={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#6B7280',
                width: 60,
                pt: 0.5
              }} data-id="element-4314">
                      13:45:00
                    </Typography>
                    <Box sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#AE2A19',
                mt: 0.8,
                mx: 1.5,
                border: '2px solid #FFFFFF'
              }} data-id="element-4315" />
                    <Typography variant="body2" color="#AE2A19" sx={{
                pt: 0.2,
                fontWeight: 600
              }} data-id="element-4316">
                      CBS Error: Insufficient funds in source GL
                    </Typography>
                  </Box>}

                <Box sx={{
              display: 'flex',
              position: 'relative',
              zIndex: 1
            }} data-id="element-4317">
                  <Typography sx={{
                fontFamily: 'monospace',
                fontSize: '12px',
                color: '#6B7280',
                width: 60,
                pt: 0.5
              }} data-id="element-4318">
                    14:30:00
                  </Typography>
                  <Box sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: '#D1D5DB',
                mt: 0.8,
                mx: 1.5,
                border: '2px solid #FFFFFF'
              }} data-id="element-4319" />
                  <Typography variant="body2" color="#6B7280" sx={{
                pt: 0.2
              }} data-id="element-4320">
                    Expected settlement completion
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{
          p: 3,
          borderTop: '1px solid #E5E7EB'
        }} data-id="element-4321">
              <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%'
          }} data-id="element-4322">
                <Box sx={{
              display: 'flex',
              gap: 1
            }} data-id="element-4323">
                  {selectedSettlement.status === 'Failed' && <Button variant="contained" sx={{
                bgcolor: '#0052CC',
                '&:hover': {
                  bgcolor: '#003DA8'
                }
              }} data-id="element-4324">
                      Retry Settlement
                    </Button>}
                  {(selectedSettlement.status === 'Processing' || selectedSettlement.status === 'Failed') && <Button variant="contained" sx={{
                bgcolor: '#AE2A19',
                '&:hover': {
                  bgcolor: '#8B1D0F'
                }
              }} data-id="element-4325">
                      Reverse Settlement
                    </Button>}
                  <Button variant="contained" sx={{
                bgcolor: '#0052CC',
                '&:hover': {
                  bgcolor: '#003DA8'
                }
              }} data-id="element-4326">
                    Manual Review
                  </Button>
                </Box>
                <Box sx={{
              display: 'flex',
              gap: 1
            }} data-id="element-4327">
                  <Button variant="outlined" sx={{
                color: '#6B7280',
                borderColor: '#D1D5DB',
                bgcolor: '#F3F5F7'
              }} data-id="element-4328">
                    Print Receipt
                  </Button>
                  <Button variant="outlined" onClick={handleCloseModal} sx={{
                color: '#374151',
                borderColor: '#D1D5DB'
              }} data-id="element-4329">
                    Close
                  </Button>
                </Box>
              </Box>
            </DialogActions>
          </>}
      </Dialog>
    </Box>;
}